




















































































































import { Component, Vue } from 'vue-property-decorator';
import SideNav from './components/reusable/SideNav.vue';
import User from '@/models/User';
import UserService from '@/services/UserService';

@Component({
    components: {
        SideNav
    }
})
export default class App extends Vue {
    private SidebarState: number = 1
    private TopBarSideClass: string = '';
    private isHidden: boolean = true;

    private GetUsername(): string {
        const usrInfo: User = this.$store.state.userInfo;

        if (usrInfo != null) {
            return `${usrInfo.FirstName} ${usrInfo.LastName}`;
        } else {
            return '';
        }
    }

    private ToggleSidebar() {
        if (this.SidebarState === -1) {
            if (screen.width < 1024) {
                this.SidebarState = 1;
                this.TopBarSideClass = 'topbar-left-closed';
            } else {
                this.SidebarState = 0;
                this.TopBarSideClass = '';
            }
        } else {
            this.SidebarState = -1;
            this.TopBarSideClass = 'topbar-left-closed';
        }
    }

    private async Logout() {
        const userService = new UserService();
        await userService.Logout();
        this.$router.push('/login');
    }

    private ShowMenu() {
        if (this.isHidden) {
            this.isHidden = false;
        } else {
            this.isHidden = true;
        }
    }
}
